import HrUnavailability, {
  HrUnavailabilityQueryParams,
  PatchHrUnavailability,
  PostHrUnavailability,
} from "app/models/hrUnavailability"

export enum Types {
  GET = "HR_UNAVAILABILITIES_GET",
  GET_SUCCESS = "HR_UNAVAILABILITIES_GET_SUCCESS",
  GET_FAIL = "HR_UNAVAILABILITIES_GET_FAIL",
  POST = "HR_UNAVAILABILITIES_POST",
  POST_SUCCESS = "HR_UNAVAILABILITIES_POST_SUCCESS",
  POST_FAIL = "HR_UNAVAILABILITIES_POST_FAIL",
  PATCH = "HR_UNAVAILABILITIES_PATCH",
  PATCH_SUCCESS = "HR_UNAVAILABILITIES_PATCH_SUCCESS",
  PATCH_FAIL = "HR_UNAVAILABILITIES_PATCH_FAIL",
}

export type Action =
  | GetHrUnavailabilitiesAction
  | GetHrUnavailabilitiesSuccessAction
  | GetHrUnavailabilitiesFailAction
  | PostHrUnavailabilitiesAction
  | PostHrUnavailabilitiesSuccessAction
  | PostHrUnavailabilitiesFailAction
  | PatchHrUnavailabilitiesAction
  | PatchHrUnavailabilitiesSuccessAction
  | PatchHrUnavailabilitiesFailAction

export type GetHrUnavailabilitiesAction = {
  type: Types.GET
  payload: { params: HrUnavailabilityQueryParams }
}

export type GetHrUnavailabilitiesSuccessAction = {
  type: Types.GET_SUCCESS
  payload: { hrUnavailabilities: HrUnavailability[] }
}

export type GetHrUnavailabilitiesFailAction = {
  type: Types.GET_FAIL
  payload: { errors: object }
}

export type PostHrUnavailabilitiesAction = {
  type: Types.POST
  payload: { hrUnavailabilities: PostHrUnavailability[] }
}

export type PostHrUnavailabilitiesSuccessAction = {
  type: Types.POST_SUCCESS
  payload: { hrUnavailabilities: HrUnavailability[] }
}

export type PostHrUnavailabilitiesFailAction = {
  type: Types.POST_FAIL
  payload: { errors: object }
}

export type PatchHrUnavailabilitiesAction = {
  type: Types.PATCH
  payload: { hrUnavailabilities: PatchHrUnavailability[] }
}

export type PatchHrUnavailabilitiesSuccessAction = {
  type: Types.PATCH_SUCCESS
  payload: { hrUnavailabilities: HrUnavailability[] }
}

export type PatchHrUnavailabilitiesFailAction = {
  type: Types.PATCH_FAIL
  payload: { errors: object }
}

export function getHrUnavailabilities(params: HrUnavailabilityQueryParams): GetHrUnavailabilitiesAction {
  return {
    payload: { params },
    type: Types.GET,
  }
}

export function getHrUnavailabilitiesSuccess(
  hrUnavailabilities: HrUnavailability[],
): GetHrUnavailabilitiesSuccessAction {
  return {
    payload: { hrUnavailabilities },
    type: Types.GET_SUCCESS,
  }
}

export function getHrUnavailabilitiesFail(errors: object): GetHrUnavailabilitiesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function postHrUnavailabilities(hrUnavailabilities: PostHrUnavailability[]): PostHrUnavailabilitiesAction {
  return {
    payload: { hrUnavailabilities },
    type: Types.POST,
  }
}

export function postHrUnavailabilitiesSuccess(
  hrUnavailabilities: HrUnavailability[],
): PostHrUnavailabilitiesSuccessAction {
  return {
    payload: { hrUnavailabilities },
    type: Types.POST_SUCCESS,
  }
}

export function postHrUnavailabilitiesFail(errors: object): PostHrUnavailabilitiesFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}

export function patchHrUnavailabilities(hrUnavailabilities: PatchHrUnavailability[]): PatchHrUnavailabilitiesAction {
  return {
    payload: { hrUnavailabilities },
    type: Types.PATCH,
  }
}

export function patchHrUnavailabilitiesSuccess(
  hrUnavailabilities: HrUnavailability[],
): PatchHrUnavailabilitiesSuccessAction {
  return {
    payload: { hrUnavailabilities },
    type: Types.PATCH_SUCCESS,
  }
}

export function patchHrUnavailabilitiesFail(errors: object): PatchHrUnavailabilitiesFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_FAIL,
  }
}
